export const getConfidenceColor = (confidence: number): string => {
  // Map confidence (0-1) to a muted color gradient from red to yellow to green
  if (confidence < 0.5) {
    // Muted Red (200,80,60) to Muted Yellow (200,180,60)
    const ratio = confidence / 0.5
    const green = Math.round(80 + 100 * ratio)
    return `rgb(200, ${green}, 60)`
  } else {
    // Muted Yellow (200,180,60) to Muted Green (80,180,60)
    const ratio = (confidence - 0.5) / 0.5
    const red = Math.round(200 - 120 * ratio)
    return `rgb(${red}, 180, 60)`
  }
}
